export default __webpack_public_path__ + "static/docs-81cb5783725b9ed377f38f0c53c0c663.png";